import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IFoThucDonCaAn, IFoThucDonNgayAn } from "../../../models/response/dich-vu/food/fo_thucdon_theongay";
import { eFoThucDonActionTypeIds, IFoThucDonActionTypes } from "../../action-types/dich-vu/IFoThucDonActionTypes";
import { IFoThucDonPageStateModel } from "../../page-state-model/dich-vu/IFoThucDonPageState";

const initialState: IFoThucDonPageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	ngay_ans: [],
	fo_caans: [],
	fo_monan_chitiets: [],
	is_show_import_modal: false,
	import_status: ePageBaseStatus.is_not_initialization,
	import_validated_datas: []
}

export const foThucDonReducer = (state: IFoThucDonPageStateModel = initialState, action: IFoThucDonActionTypes): IFoThucDonPageStateModel => {
	switch (action.type) {
		case eFoThucDonActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading,
				ngay_ans: []
			}
		case eFoThucDonActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				ngay_ans: (action.payload?.ngay_ans as IFoThucDonNgayAn[]) || []
			}
		case eFoThucDonActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				ngay_ans: []
			}
		case eFoThucDonActionTypeIds.LOAD_CAAN_START:
			return {
				...state
			}
		case eFoThucDonActionTypeIds.LOAD_CAAN_SUCCESS:
			return {
				...state,
				fo_caans: action.payload
			}
		case eFoThucDonActionTypeIds.LOAD_CAAN_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				fo_caans: []
			}
		case eFoThucDonActionTypeIds.LOAD_MONAN_START:
			return {
				...state
			}
		case eFoThucDonActionTypeIds.LOAD_MONAN_SUCCESS:
			return {
				...state,
				fo_monan_chitiets: action.payload
			}
		case eFoThucDonActionTypeIds.LOAD_MONAN_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				fo_monan_chitiets: []
			}
		case eFoThucDonActionTypeIds.CHANGE_MONAN: {
			const { row_index, fo_caan_id, fo_monan_chitiet_ids } = action.payload;
			return {
				...state,
				ngay_ans: state.ngay_ans.map((ngay: IFoThucDonNgayAn, idx: number) => {
					if (idx !== row_index) return ngay;
					return {
						...ngay,
						ca_an: (ngay.ca_an || []).map((ca: IFoThucDonCaAn) => {
							if (ca.fo_caan_id !== fo_caan_id) return ca;
							return { ...ca, fo_monan_chitiet_id: fo_monan_chitiet_ids };
						})
					};
				})
			}
		}
		case eFoThucDonActionTypeIds.SAVE_MULTIPLE_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eFoThucDonActionTypeIds.SAVE_MULTIPLE_SUCCESS:
			NotifyHelper.Success("Cập nhật thành công")
			return {
				...state,
				status: ePageBaseStatus.is_completed
			}
		case eFoThucDonActionTypeIds.SAVE_MULTIPLE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_need_reload
			}
		case eFoThucDonActionTypeIds.SHOW_IMPORT_MODAL:
			return {
				...state,
				is_show_import_modal: true,
				import_status: ePageBaseStatus.is_not_initialization,
				import_validated_datas: []
			}
		case eFoThucDonActionTypeIds.CLOSE_IMPORT_MODAL:
			return {
				...state,
				is_show_import_modal: false,
				import_status: ePageBaseStatus.is_not_initialization,
				import_validated_datas: []
			}
		case eFoThucDonActionTypeIds.VALIDATE_IMPORT_START:
			return {
				...state,
				import_status: ePageBaseStatus.is_loading
			}
		case eFoThucDonActionTypeIds.VALIDATE_IMPORT_SUCCESS:
			return {
				...state,
				import_status: ePageBaseStatus.is_completed,
				import_validated_datas: action.payload || []
			}
		case eFoThucDonActionTypeIds.VALIDATE_IMPORT_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				import_status: ePageBaseStatus.is_completed,
				import_validated_datas: []
			}
		case eFoThucDonActionTypeIds.IMPORT_START:
			return {
				...state,
				import_status: ePageBaseStatus.is_saving
			}
		case eFoThucDonActionTypeIds.IMPORT_SUCCESS:
			NotifyHelper.Success("Import thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				import_status: ePageBaseStatus.is_completed,
				is_show_import_modal: false,
				import_validated_datas: []
			}
		case eFoThucDonActionTypeIds.IMPORT_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				import_status: ePageBaseStatus.is_completed
			}
		default:
			return state;
	}
}
